var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"certs"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.LANG_HEADER))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }